import Tag from '@/models/Tag'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1,
    },
  },
  mutations: {
    setTagList(state, tags) {
      each(tags, (tag) => {
        const exist = find(state.list, { id: tag.id })
        if (!exist) {
          state.list.push(new Tag(tag))
        }
      })
    },
    setTagListMeta(state, meta) {
      state.listMeta = meta
    },
  },

  actions: {
    async getTags({ commit }, params) {
      const query = Tag.page(params.page || 1)

      if (params.search) {
        query.where('search', params.search)
      }

      const res = await query
        .params({ limit: 20, 'filter[type]': params.type })
        .get()

      commit('setTagList', res.data)
      commit('setTagListMeta', res.meta)
    },
  },
}
